<template>
  <div class="Process">
    <div class="page-title">{{ title }}</div>
    <div class="pb-default">
      <ATable
        ref="table"
        hide-button-insert
        highlight-current-row
        v-loading="loading"
        max-height="750px"
        :placeholder="placeholder"
        :search_field="search_field"
        :data="items"
        border
        hide-pagination
        @row-click="handleClickRow"
        @selection-change="handleSelectionChange"
      >
        <div slot="search">
          <div class="inline">
            <APeriodSelector
              ref="period"
              value="0d"
              @change="handleChangePeriod"
            />
          </div>
          <div class="inline">
            <el-button
              type="primary"
              size="mini"
              round
              v-shortkey="['f5']"
              @shortkey.native="handleClickSearch"
              @click="handleClickSearch"
              >{{ $t("button.search") }}(F5)</el-button
            >
          </div>
        </div>
        <el-table-column
          type="selection"
          align="center"
          :width="$width.selection"
          :selectable="selectable"
        />
        <el-table-column
          :label="$t('lang.No')"
          :width="$width.index"
          :index="handleIndex"
          type="index"
        ></el-table-column>
        <el-table-column
          prop="code"
          :label="$t('lang.production_num')"
          width="90"
        />
        <el-table-column
          prop="customer_name"
          :label="$t('lang.customer_name')"
          width="140"
          show-overflow-tooltip
        />
        <el-table-column
          prop="product_name"
          :label="$t('lang.product')"
          show-overflow-tooltip
        />
        <el-table-column
          prop="specification"
          :label="$t('lang.specification')"
          width="160"
          show-overflow-tooltip
        />
        <el-table-column
          prop="desc"
          label="비고"
          width="160"
          show-overflow-tooltip
        />
        <el-table-column prop="plan_amount" label="지시량" width="60" />
        <el-table-column prop="amount" label="생산량" width="60" />
        <el-table-column :label="$t('lang.production')" width="60">
          <template slot-scope="scope">
            <div
              class="circle"
              v-bind:class="resolveStatus(scope.row.status_flag)"
            >
              {{ resolveStatusText(scope.row.status_flag) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.label')" width="60">
          <template slot-scope="scope">
            <div class="circle" v-bind:class="resolvePrintStatus(scope.row)">
              {{ resolvePrintStatusText(scope.row) }}
            </div>
          </template>
        </el-table-column>
      </ATable>
    </div>
    <div class="flex">
      <div>
        <!-- <el-button
          type="primary"
          :disabled="selection.length < 1 || !has_grant_write"
          @click="handleClickStart"
        >{{ $t('button.production_start') }}</el-button> -->
        <el-button
          type="primary"
          :disabled="selection.length < 1 || !has_grant_write"
          @click="handleClickCompleted"
          >{{ $t("button.production_complete") }}</el-button
        >
      </div>
      <div v-show="selectedData" class="ml-default">
        <el-button @click="handleClickViewBom">생산계획</el-button>
        <!-- <el-button
          type="primary"
          :disabled="!isWorking || !has_grant_write"
          @click="handleClickResult"
        >{{ $t('button.result_regist') }}</el-button> -->
        <el-button
          type="primary"
          :disabled="!has_grant_write"
          @click="handleClickFailure"
          >{{ $t("button.failure_regist") }}</el-button
        >
        <el-button :disabled="!isStarted" @click="handleClickPrint">{{
          $t("button.print")
        }}</el-button>
      </div>
    </div>
    <el-dialog
      title="작업 수량 등록"
      top="0"
      custom-class="number-key-dialog"
      destroyOnClose
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    >
      <ResultForm
        ref="form"
        v-if="dialogVisible"
        @completed="handleCompletedOnResultForm"
      />
    </el-dialog>
    <el-dialog
      title="불량 등록"
      top="0"
      custom-class="form-dialog"
      destroyOnClose
      :visible.sync="dialog2Visible"
      :close-on-click-modal="false"
    >
      <FailureForm
        ref="form"
        v-if="dialog2Visible"
        :data="selectedData"
        @completed="handleCompletedOnFailureForm"
      />
    </el-dialog>
    <el-dialog
      custom-class="form-dialog"
      top="0"
      width="600px"
      style="height: 100%"
      :title="$t('button.print')"
      :visible.sync="dialog3Visible"
      :close-on-click-modal="false"
      append-to-body
      destroyOnClose
    >
      <PrintView
        ref="print"
        v-if="dialog3Visible"
        :data="selectedData"
        @completed="handleCompletePrintView"
      />
    </el-dialog>
    <el-dialog
      title="생산 계획"
      top="0"
      custom-class="form-dialog"
      destroyOnClose
      :visible.sync="dialog4Visible"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      @opened="handleOpened"
    >
      <BomView
        ref="form"
        v-if="dialog4Visible"
        :data="selectedData"
        @completed="handleCompletedBomView"
      />
    </el-dialog>
  </div>
</template>
<script>
import { form_container } from "@/common/mixins/form_container";
import { authority_level } from "@/common/mixins/authority_level";
import { production_process } from "@/common/mixins/production_process";
import ResultForm from "./ResultForm";
import FailureForm from "./FailureForm";
import PrintView from "./PrintView";
import BomView from "./BomView";

export default {
  name: "Process",
  mixins: [form_container, authority_level, production_process],
  components: { ResultForm, FailureForm, PrintView, BomView },
  data() {
    return {
      title: this.$t("title.production_result"),
      search_field: ["code", "customer_name", "product_name"],
      placeholder: "생산번호, 거래처, 품목",
      loading: false,
      items: [],
      period: {},
      selectedData: null,
      dialogVisible: false,
      dialog2Visible: false,
      dialog3Visible: false,
      dialog4Visible: false,
      selection: [],
    };
  },
  computed: {
    isReady() {
      if (!this.selectedData) {
        return false;
      }
      return this.selectedData.status_flag === "0";
    },
    isProcessing() {
      if (!this.selectedData) {
        return false;
      }
      return this.selectedData.status_flag === "1";
    },
    isWorking() {
      if (!this.selectedData) {
        return false;
      }
      return (
        this.selectedData.status_flag === "1" &&
        this.selectedData.plan_amount !== this.selectedData.amount
      );
    },
    isFinished() {
      if (!this.selectedData) {
        return false;
      }
      return (
        this.selectedData.status_flag === "1" &&
        this.selectedData.plan_amount === this.selectedData.amount
      );
    },
    isCompleted() {
      if (!this.selectedData) {
        return false;
      }
      return ["0", "2"].includes(this.selectedData.status_flag);
    },
    isStarted() {
      if (!this.selectedData) {
        return false;
      }
      return ["1", "2"].includes(this.selectedData.status_flag);
    },
    has_grant_write() {
      return this.isWriteLevel("production_result");
    },
  },
  mounted() {
    this.$nextTick(() => this.loadData());
  },
  methods: {
    loadData() {
      this.loading = true;
      this.api.listProduction(this.period).then((res) => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items = res.data;
      });
    },
    doStart() {
      let ids = this.selection.map((s) => s.id);
      this.processProduction(
        "생산 시작 처리 중입니다.",
        () => this.api.updateProductionStart(ids),
        {
          success: (res) => (this.selectedData = res.data),
          // 생산은 건별로 처리되므로 오류가 나도 앞 건은 반영되어 있다.
          always: () => this.loadData(),
        }
      );
    },
    doComplete() {
      let ids = this.selection.map((s) => s.id);
      this.processProduction(
        "생산 완료 처리 중입니다.",
        () => this.api.updateProductionFinish(ids),
        {
          success: (res) => (this.selectedData = res.data),
          // 생산은 건별로 처리되므로 오류가 나도 앞 건은 반영되어 있다.
          always: () => this.loadData(),
        }
      );
    },
    handleChangePeriod(value) {
      this.period = value;
    },
    handleClickSearch() {
      if (!this.period.valid) {
        return;
      }
      this.loadData();
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleClickRow(data) {
      this.selectedData = data;
    },
    handleClickStart() {
      this.util.confirm(
        this,
        this.title,
        "생산을 시작하시겠습니까?",
        this.doStart
      );
    },
    handleClickCompleted() {
      this.util.confirm(
        this,
        this.title,
        "생산을 완료하시겠습니까?",
        this.doComplete
      );
    },
    handleClickResult() {
      this.dialogVisible = true;
    },
    handleCompletedOnResultForm(value) {
      if (!value) {
        this.dialogVisible = false;
        return;
      }
      if (this.selectedData.plan_amount < this.selectedData.amount + value) {
        this.util.notify(
          this,
          "e",
          this.title,
          "수주량보다 작업수량이 많습니다."
        );
        return;
      }
      this.dialogVisible = false;
      let params = { id: this.selectedData.id, amount: value };
      this.processProduction(
        "실적 등록 중입니다.",
        () => this.api.updateProductionResult(params),
        {
          success: (res) => (this.selectedData = res.data),
          always: () => this.loadData(),
        }
      );
    },
    handleClickFailure() {
      this.dialog2Visible = true;
    },
    handleCompletedOnFailureForm() {
      this.dialog2Visible = false;
      // if (!params) {
      //   return;
      // }
      // params.id = this.selectedData.id;
      // this.api.updateProductionFailure(params).then(res => {
      //   if (res.error !== this.system.noError) {
      //     this.util.notify_response_error(this, this.title, res);
      //     return;
      //   }
      //   this.loadData();
      //   this.selectedData = res.data;
      // });
    },
    handleClickPrint() {
      this.api.updateProductionPrint(this.selectedData).then((res) => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.dialog3Visible = true;
      });
    },
    handleCompletePrintView() {
      this.dialog3Visible = false;
    },
    resolveStatus(status_flag) {
      switch (status_flag) {
        case "2":
          return "completed";
        case "1":
          return "processing";
        default:
          return "none";
      }
    },
    resolveStatusText(status_flag) {
      if (status_flag === "2") {
        return "V";
      } else {
        return "1";
      }
    },
    resolvePrintStatus(data) {
      if (data.print_flag === "Y") {
        return "completed";
      } else {
        switch (data.status_flag) {
          case "2":
            return "processing";
          case "1":
            return "waiting";
          default:
            return "none";
        }
      }
    },
    resolvePrintStatusText(data) {
      if (data.print_flag === "Y") {
        return "V";
      } else {
        return "2";
      }
    },
    resolvePackStatus(data) {
      if (data.package_flag === "Y") {
        return "completed";
      } else {
        switch (data.status_flag) {
          case "2":
            return "waiting";
          case "1":
            return "standby";
          default:
            return "none";
        }
      }
    },
    resolveShipmentStatus(data) {
      if (data.shipment_flag === "Y") {
        return "completed";
      } else if (data.package_flag === "Y") {
        return "processing";
      } else {
        switch (data.status_flag) {
          case "2":
            return "waiting";
          case "1":
            return "standby";
          default:
            return "none";
        }
      }
    },
    handleClickViewBom() {
      this.dialog4Visible = true;
    },
    handleCompletedBomView() {
      this.dialog4Visible = false;
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    selectable(row) {
      return row.status_flag !== "2";
    },
  },
};
</script>
<style lang="scss">
.circle {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  border: 1px solid #666;
  margin: 5px 15px 5px 15px;
  line-height: 18px;
  text-align: center;
  font-weight: bold;
}
.none {
  background-color: black;
  color: white;
}
.waiting {
  background-color: orange;
  color: white;
}
.processing {
  background-color: green;
  color: white;
}
.standby {
  background-color: yellow;
  color: black;
}
.completed {
  background-color: blue;
  color: white;
}
</style>
